// extracted by mini-css-extract-plugin
module.exports = {"select":"CountryPicker_select__2BqZV","flag":"CountryPicker_flag__3M-iH"};